 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"1bfc9850","2":"ad845454c77e5774e39c43761c46a15aa302ed13","3":"d7eeaac4","4":"7f74d7ab3533ded8c7a7b925232f82de0ef12c64","5":"0c428ae2","6":"686e2384ff3d91127f43a8eeedc60ae3cd6d8040","7":"61b17f69dc1d0e803e4fa39b3ab48b0724386343","8":"171b3e72f0d6a0c0cdb0282988c6c105028c2b2c","9":"415b536452cd4456fe9d42bfa0cb5893acf496f0","12":"component---src-pages-404-js","13":"component---src-pages-about-us-js","14":"component---src-pages-contact-us-js","15":"component---src-pages-index-js","16":"component---src-pages-industry-aerospace-and-defense-component-manufacturing-js","17":"component---src-pages-industry-automotive-component-manufacturing-js","18":"component---src-pages-industry-consumer-durables-js","19":"component---src-pages-industry-hardware-startups-component-manufacturing-js","20":"component---src-pages-industry-industrial-machinery-component-manufacturing-js","21":"component---src-pages-industry-medical-equipment-and-devices-manufacturing-js","22":"component---src-pages-industry-telecommunication-equipment-manufacturing-js","23":"component---src-pages-partner-network-js","24":"component---src-pages-quality-assurance-js","25":"component---src-pages-service-casting-services-js","26":"component---src-pages-service-cnc-machining-services-js","27":"component---src-pages-service-metal-fabrication-services-js","28":"component---src-pages-service-metal-forging-services-js","29":"component---src-pages-service-metal-injection-molding-services-js","30":"component---src-pages-service-metal-stamping-services-js","31":"component---src-pages-service-plastic-injection-molding-services-js","32":"component---src-pages-service-prototyping-services-js","33":"component---src-templates-blog-js","34":"component---src-templates-blog-landing-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"ba21adb5cbf25b816002","2":"7fe5b2d15416671639d2","3":"74adfb70f44efda3dfec","4":"d4bb08dd4f3e45de5381","5":"35f229c9ad62f1b3285e","6":"142300e654ca46f33113","7":"9e2c27227d622b1e6d2b","8":"8518c5356205a4f05b33","9":"e5fa8ab7297bd1fa4e7c","12":"53cbf5701cea3c1fa5f2","13":"40ed4254b17635c8e076","14":"b36fd738185aaf53d381","15":"fc609811640cc3a73c78","16":"3bf811a067eafacfa8c3","17":"44d387126e3f6c99ff54","18":"8a41fbf9ea50f58bf6b0","19":"be0023264c2c9756081b","20":"c86ef60ff04a711dcbc6","21":"e33a4ae813519bef4bd5","22":"287f99208e2052533ed4","23":"3a81e3026545f340d8bb","24":"224f8ad12489009c576f","25":"93ea4430544b5d8da148","26":"5f6812242e7f0c64c3c8","27":"26cc8a9089d0f086a415","28":"c26dc2fd58ee67322ae8","29":"7a3d5aaa728a72c0cd84","30":"8acc490e398e2901c029","31":"3129e9558b06162d8b92","32":"d55db63dc41d08d167b0","33":"e091fb6991bc56c2f9f1","34":"733b3c7f49f7b424748d","37":"d2583fd204ad3a332fec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"1bfc9850","2":"ad845454c77e5774e39c43761c46a15aa302ed13","3":"d7eeaac4","4":"7f74d7ab3533ded8c7a7b925232f82de0ef12c64","5":"0c428ae2","6":"686e2384ff3d91127f43a8eeedc60ae3cd6d8040","7":"61b17f69dc1d0e803e4fa39b3ab48b0724386343","8":"171b3e72f0d6a0c0cdb0282988c6c105028c2b2c","9":"415b536452cd4456fe9d42bfa0cb5893acf496f0","12":"component---src-pages-404-js","13":"component---src-pages-about-us-js","14":"component---src-pages-contact-us-js","15":"component---src-pages-index-js","16":"component---src-pages-industry-aerospace-and-defense-component-manufacturing-js","17":"component---src-pages-industry-automotive-component-manufacturing-js","18":"component---src-pages-industry-consumer-durables-js","19":"component---src-pages-industry-hardware-startups-component-manufacturing-js","20":"component---src-pages-industry-industrial-machinery-component-manufacturing-js","21":"component---src-pages-industry-medical-equipment-and-devices-manufacturing-js","22":"component---src-pages-industry-telecommunication-equipment-manufacturing-js","23":"component---src-pages-partner-network-js","24":"component---src-pages-quality-assurance-js","25":"component---src-pages-service-casting-services-js","26":"component---src-pages-service-cnc-machining-services-js","27":"component---src-pages-service-metal-fabrication-services-js","28":"component---src-pages-service-metal-forging-services-js","29":"component---src-pages-service-metal-injection-molding-services-js","30":"component---src-pages-service-metal-stamping-services-js","31":"component---src-pages-service-plastic-injection-molding-services-js","32":"component---src-pages-service-prototyping-services-js","33":"component---src-templates-blog-js","34":"component---src-templates-blog-landing-js"}[chunkId]||chunkId) + "." + {"0":"8bf90496fec5aec8c6a2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
